import Layout from '@/layout'
import { checkCfsPermission } from '@/utils/permission'

const hideChefCommission = checkCfsPermission('CHEF_Commission.SEARCH') && checkCfsPermission('PAGE')
const hideChefCommissionSettlement = checkCfsPermission('CHEF_COMMISSION_SETTLEMENT.SEARCH') && checkCfsPermission('order')

const chefRouter = {
  path: '/chef',
  component: Layout,
  alwaysShow: true,
  redirect: '/chef/chefCommission',
  name: 'chef',
  hidden: false,
  meta: {
    title: 'chefMenu.title', // CHEF
    icon: 'peoples'
  },
  children: [
    {
      path: '/chef/chefCommission',
      component: () => import('@/views/spread/chefCommission'),
      name: 'chefCommission',
      meta: {
        title: 'chefMenu.commission_setting', // CHEF分潤設定
        noCache: false
      },
      hidden: hideChefCommission
    },
    {
      path: '/chef/chefCommissionRecord',
      component: () => import('@/views/market/chefCommissionRecord'),
      name: 'chefCommissionRecord',
      meta: {
        title: 'chefMenu.commission_detail', // CHEF分潤明細
        noCache: false
      },
      hidden: hideChefCommission
    },
    {
      path: '/chef/chefCommissionSettlement',
      component: () => import('@/views/market/chefCommissionSettlement'),
      name: 'chefCommissionSettlement',
      meta: { title: 'chefMenu.commission_report', noCache: false }, // CHEF分潤報表
      hidden: hideChefCommissionSettlement
    },
    {
      path: '/chef/chefCommissionEdit',
      component: () => import('@/views/spread/chefCommissionForm'),
      name: 'chefCommissionEdit',
      meta: {
        title: 'chefMenu.edit_commission_setting', // 編輯CHEF分潤設定
        noCache: false,
        activeMenu: '/chef/chefCommission'
      },
      hidden: true
    },
    {
      path: '/chef/chefCommissionAdd',
      component: () => import('@/views/spread/chefCommissionForm'),
      name: 'chefCommissionAdd',
      meta: {
        title: 'chefMenu.add_commission_setting', // 新增CHEF分潤設定
        noCache: false,
        activeMenu: '/chef/chefCommission'
      },
      hidden: true
    },
    {
      path: '/chef/chefCommissionSettlement/detail',
      component: () => import('@/views/market/chefCommissionSettlementDetail'),
      name: 'chefCommissionSettlementDetail',
      meta: {
        title: 'chefMenu.commission_report_detail', // 分潤報表明細
        noCache: false,
        activeMenu: '/chef/chefCommissionSettlement'
      },
      hidden: true
    },
    {
      path: '/chef/chefCommissionSettlement/batch-update',
      component: () => import('@/views/market/chefCommissionSettlementBatchUpdate'),
      name: 'chefCommissionSettlementBatchUpdate',
      meta: {
        title: 'chefMenu.commission_report_batch_update', // 批次編輯模式
        noCache: true,
        activeMenu: '/chef/chefCommissionSettlement'
      },
      hidden: true
    }
  ]
}

export default chefRouter
